<template>
    <div class="action-verification-completed">
        <div class="title f-bold" v-html="$translate('ACTION_VERIFICATION_COMPLETED')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionVerificationCompleted',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            const body = this.$translate('ACTION_VERIFICATION_COMPLETED_BODY')
            return body.replace(/%s/, this.message.content)
        },
    },
}
</script>
